<template>
  <div class="content">
    <div class="fx__box menu-container">
      <div class="parentmenu fx__bgcolor-primary offset" style="user-select: none;">
        <span class="fx__Fold" @click="expandAll(false)" v-if="IsFoldAll">
          <i class="fa-lg" :class="CurrentMenu.icon ? CurrentMenu.icon : ' fa fa-navicon '"></i>
          {{ CurrentMenu.text }}
          <span class="fa fa-angle-down fa-lg sub_span" :style="`transform: rotate(${IsFoldAll ? '-90' : '0'}deg)`" style="user-select: none; transition: all 0.2s;"></span>
        </span>
        <span class="fx__Fold" @click="expandAll(true)" v-else>
          <i class="fa-lg" :class="CurrentMenu.icon ? CurrentMenu.icon : ' fa fa-navicon '"></i>
          {{ CurrentMenu.text }}
          <span class="fa fa-angle-down fa-lg sub_span" :style="`transform: rotate(${IsFoldAll ? '-90' : '0'}deg)`" style="user-select: none; transition: all 0.2s;"></span>
        </span>
        <div class="submenu">
          <div style="width:200px;overflow: hidden;border-radius: 3px;" :class="[input_show||keyword?'submenuinput_focus':'submenuinput']">
            <input class="ivu-input" @mousemove="inputMove" @mouseout="inputOut" @mouseleave="inputOut" placeholder="输入关键字可搜索" v-model.trim="keyword" @focus="inputFocus" @blur="inputBlur" />
          </div>
          <span @mousemove="inputMove" @mouseout="inputOut" @mouseleave="inputOut" style="margin-left: 8px;cursor: pointer" class="fa fa-search fa-lg "></span>
        </div>
      </div>

      <div style="overflow-y: auto;">
        <div class="childContainer" v-if="sunTopArr.length > 0">
          <div class="secondContainer">
            <menuItem :Menu="item1" :isDing="dingKeyArr.includes(item1.name)" @on-ding="handlerClickDing" v-for="(item1, index1) in sunTopArr" :key="index1">
            </menuItem>
          </div>
        </div>
        <div class="childContainer" style="user-select: none;">
          <div class="childmenu" v-for="(menu, index) in menuGroups" :key="menu.menukey">
            <div style="display: flex;">
              <div class="secondTitle" @click="menuExpand(menu.menukey, index)">
                <span class="fa fa-angle-down fa-lg sub_span" :style="`transform: rotate(${!menuKeyDict[menu.menukey].expand ? '-90' : '0'}deg)`" style="user-select: none;"></span>
                {{ menu.text }}
              </div>
              <div style="flex: 1;"></div>
            </div>
            <div class="secondContainer">
              <menuItem v-for="(menuItem, itemIndex) in menu.children" :key="itemIndex" :Menu="menuItem" :IsFold="!menuKeyDict[menu.menukey].expand" :isDing="dingKeyArr.includes(menuItem.name)" @on-ding="handlerClickDing">
              </menuItem>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItem from "./menuItem"

export default {
  props: {
    CurrentMenu: Object,
  },
  components: { menuItem },
  data() {
    let _menuKeyDict = {}
    _menuKeyDict["other"] = {
      expand: true,
    }
    this.CurrentMenu.children.forEach((element) => {
      let { menukey } = element
      _menuKeyDict[menukey] = {
        expand: true,
      }
    })

    return {
      dSubmenukeyword: "", //防抖过后的关键字
      menuKeyDict: _menuKeyDict,
      keyword: "", //关键字
      input_show: false,
      isFocus: false,
      IsFoldAll: false,
      foldAllIcon: false,
      submenufun: null,
    }
  },
  watch: {
    keyword: {
      handler: function (newval, oldval) {
        //防抖设计
        let _this = this
        if (_this.submenufun !== null) {
          clearTimeout(_this.submenufun)
        }
        _this.submenufun = setTimeout(() => {
          _this.dSubmenukeyword = newval
        }, 300)
      },
      immediate: true,
    },
    // menuGroups: {
    //   handler: function (newval, oldval) {
    //     //防抖设计
    //     let _this = this;
    //     console.log(newval);
    //   },
    //   immediate: true,
    // },
  },
  computed: {
    menuGroups() {
      let _this = this
      // let menusindex = parseInt(this.$route.params.index);
      let keyword = this.dSubmenukeyword || ""
      let { text, svg, name, menukey, icon, children } = this.CurrentMenu

      let _arr = []
      let otherArr = {
        text: "其他",
        name: "other",
        menukey: "other",
        // IsFold: true,
        expand: true, //这里的expand是用于记录的
        children: [],
      }
      let _dingKeyArr = _this.$store.state.core.menuStore.Userding.map((p) => p.name)

      for (const item of children) {
        if (item.children && item.children.length > 0) {
          //把额外属性先赋值好
          let item2 = Object.assign({ expand: true }, true, item)
          // let item2 = Object.assign({}, true, item);
          if (keyword) {
            item2.children = item2.children.filter((p) => p.text.indexOf(keyword) != -1)
          }

          if (item2.children.length == 0) continue

          item2.children.forEach((p) => {
            p.IsFold = false
            p.isDing = _dingKeyArr.includes(p.name)
          })
          if (item2.children.length == 1 && !item2.name && keyword == "") otherArr.children.push(item2.children[0])
          else {
            // item2.expand = true;
            _arr.push(item2)
          }
        }
      }

      if (otherArr.children.length > 0) {
        _arr.push(otherArr)
      }
      return _arr
    },
    sunTopArr() {
      let _this = this
      let keyword = this.dSubmenukeyword || ""
      let _arr = []
      let _dingKeyArr = _this.$store.state.core.menuStore.Userding.map((p) => p.name)
      _this.CurrentMenu.children.map((p) => {
        if (p.children == undefined || p.children == "undefined") {
          p.isDing = _dingKeyArr.includes(p.name)
          _arr.push(p)
        }
      })
      if (keyword) _arr = _arr.filter((p) => p.text.indexOf(keyword) != -1)
      return _arr
    },
    dings() {
      return this.$store.state.core.menuStore.Userding
    },
    dingKeyArr() {
      let arr = this.dings.map((p) => p.name)
      return arr
    },
  },

  methods: {
    inputFocus() {
      this.isFocus = true
      this.input_show = true
    },
    inputBlur() {
      if (this.keyword) {
        this.input_show = true
      } else {
        this.input_show = false
      }
      this.isFocus = false
    },
    inputOut() {
      if (this.isFocus) return
      this.input_show = false
    },
    inputMove() {
      if (this.input_show) return
      this.input_show = true
    },
    expandAll(isFoldAll) {
      //点击全部折叠
      let _this = this
      _this.menuGroups.map((p) => (p.expand = !isFoldAll))
      for (const [key, val] of Object.entries(_this.menuKeyDict)) {
        val.expand = !isFoldAll
      }
      _this.IsFoldAll = isFoldAll
    },
    menuExpand(key, index) {
      //点击单个折叠
      let _this = this
      _this.menuKeyDict[key].expand = !_this.menuKeyDict[key].expand
      _this.menuGroups[index].expand = !_this.menuGroups[index].expand
      if (JSON.stringify(_this.menuGroups.filter((p) => p.expand == true)) == "[]") {
        _this.IsFoldAll = true
      } else {
        _this.IsFoldAll = false
      }
    },
    handlerClickDing(item) {
      let { isDing, text } = item
      let obj = {
        title: isDing ? "移除确认" : "添加确认",
        content: isDing ? `是否将[${text}]从左侧常用菜单栏移除` : `是否将[${text}]添加到左侧常用菜单栏`,
      }
      this.saveDing(obj, item, isDing)
    },
    saveDing({ title, content }, ding, isDing) {
      let { $Modal, $Message, $store, $curl, dings } = this
      $Modal.confirm({
        title,
        content,
        onOk: () => {
          if (dings.length < 10 || isDing) {
            $store.dispatch("core/saveDing", ding).then(() => $Message.info(isDing ? "移除成功" : "添加成功"))
          } else {
            $Message.error("已超过最大钉的数量！")
          }
        },
      })
    },
  },
}
</script>
<style lang="scss" >
.submenuinput {
  .ivu-input {
    // border: none;
    transform: translateX(100%);
    // opacity: 0;
    // padding: 0;
    background: #fff !important;
    border-color: #fff !important;
    color: #515a6e !important;
    transition: all 0.4s ease 0s;
    // transform-origin: right ;
    transition-delay: 0.5s;
  }
}
.submenuinput_focus {
  .ivu-input {
    // border: none;
    // opacity: 1;
    transition: all 0.4s ease 0s;
    // transform-origin: right ;
    transform: translateX(0);
    background: #fff !important;
    border-color: #fff !important;
    color: #515a6e !important;
  }
}
</style>
<style lang="scss" scoped>
.content {
  padding: 44px 30px 20px;
  height: 100%;
  overflow: hidden;

  // overflow-y: scroll;
  .menu-container {
    height: 100%;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .submenu {
      display: flex;
      align-items: center;
      position: absolute;
      top: 21px;
      right: 16px;
    }
  }
  .offset {
    margin-top: -36px;
    margin-bottom: 20px;
    z-index: 120;
  }
  .parentmenu {
    position: relative;
    padding: 23px 20px;
    border-radius: 4px;
    font-size: 18px;
  }
  .childContainer {
    padding: 10px 20px 0;
    // overflow-y: hidden;
    // height: calc( 100% - 115px );
    // flex: 1;
    &:hover {
      // overflow-y: overlay;
    }
    .childmenu {
      &:last-of-type {
        margin-bottom: 0;
        > div {
          padding-bottom: 0 !important;
        }
      }
    }
    .icon {
      width: 68px;
      height: 68px;
      background: #e73d39;
      border-radius: 16px;
      font-size: 24px;
    }
    .secondTitle {
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      margin-bottom: 10px;
      .sub_span {
        transform: rotate(0);
        transition: all 0.2s;
      }
    }
    .secondContainer {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }
    .secondContainer1 {
      display: flex;
    }
  }
  .fx__Fold {
    cursor: pointer;
    &:hover {
      color: rgb(231, 231, 231);
    }
  }
}
</style>
